export default __webpack_public_path__ + "bb263a8aa7dacd92f257094dbdd3f25e.png";